import React from "react";
import ReactPaginate from "react-paginate";

const Paginate = ({ totalPages, setCurrentPage, containerClassName = "pagination" }) => {
  const handlePageClick = (selectedItem) => {
    setCurrentPage(selectedItem.selected);
  };

  return (
    <ReactPaginate
      previousLabel="Previous Page"
      nextLabel="Next Page"
      breakLabel={"..."}
      pageCount={totalPages}
      marginPagesDisplayed={2}
      pageRangeDisplayed={5}
      onPageChange={handlePageClick}
      containerClassName={containerClassName}
      activeClassName={"active"}
    />
  );
};

export default Paginate;
